export default __webpack_public_path__ + "static/media/wireframe1.e7148130.svg";